import React from 'react'
import clsx from 'clsx'
import { LineChart, Activity, GitBranch, ArrowLeftRight, Boxes, BarChart3, Grid3x3, CircleDollarSign, Sparkles } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { ASSETS } from '../data'
import { TONE } from '../_shared'
const ICONS = { LineChart, Activity, GitBranch, ArrowLeftRight, Boxes, BarChart3, Grid3x3, CircleDollarSign }
export default function MultiAsset() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Multi-Asset Support</Eyebrow>
          <SectionHeading align="center"
            title={<>Every market <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">your desk covers.</span></>}
            subtitle="Configure the asset classes your operators actually trade. New venues + instruments are onboarded via the API Gateway without customer-side integration work."
          />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {ASSETS.map((a) => {
            const tone = TONE[a.tone] || TONE.orange
            const Icon = ICONS[a.iconKey] || Sparkles
            return (
              <div key={a.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl overflow-hidden transition-all hover:border-white/20 hover:bg-white/[0.03] hover:-translate-y-[1px]">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.12), transparent 70%)` }} />
                <div className="relative flex flex-col items-center gap-3 text-center">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.10)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 22, height: 22 }} />
                  </span>
                  <div className="text-[14px] font-semibold text-white leading-tight">{a.label}</div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
